import MD5 from "crypto-js/md5";
import Fancybox from "../assets/fancybox";
import CartApi from "../api/CartApi";
import axios from "axios";
import {Cell, List} from "@vkontakte/vkui";
import React from "react";

import * as constants from "../assets/constants";
import Sclads from "../catalog/Sclads";
import CartTotal from "./CartTotal";

import CartRow from "./CartRow";

class Cart extends React.Component {
    state = {
        items: [],
        edit_cart_item: null,
        current_product: []

    };

    hideSclads = () => {
        this.setState({edit_cart_item: null})
        window.postMessage('showCartNext')
    }
    getItems = () => {
        CartApi.getItems((items_) => {
            this.setState({items: items_})
            console.log(this.state.items)
        })
    }
    removeFromCart = (index) => {
        let old = this.state.items;
        old.splice(index, 1);
        this.setState({items: old})
        // old = CartApi.items
        //old.splice(index, 1);
        CartApi.saveItems()
        this.props.refresh()
    }
    showEditCart = (index) => {
        const el = this.state.items[index];
        el.meta_id = el.product_id
        const username = localStorage.getItem(constants.USER_NAME);
        const password = localStorage.getItem(constants.PASSWORD);

        const body = new FormData()
        body.append('product_id', el.product_id)
        const headers = {
            //'Content-Type': 'multipart/form-data',
            'ID': username,
            'PASS': MD5(password)
        };

        axios.post(this.props.base_url + '?app=partnersproducts&act=getProduct', body,
            {
                withCredentials: true

            }
        ).then((response) => {

            this.setState({current_product: response.data.product, edit_cart_item: el});
            window.postMessage('hideCartNext')

        })
    }
    receiveMessage_ = (event) => {
        if (event.data == 'cartSaved') {
            this.refreshState()
        }
        if (event.data == 'cartGoGetBack') {
            if (this.state.edit_cart_item == null) {
                window.postMessage('goMainBack')
            } else {
                this.hideSclads()
            }
        }
    }

    componentDidMount() {
        this.getItems()
        window.addEventListener("message", this.receiveMessage_, false)
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.receiveMessage_, false)
    }


    constructor(props) {
        super(props)

    }

    refreshState = () => {
        this.getItems()

    }

    render() {


        if (this.state.edit_cart_item != null) {
            return <Sclads base_url={this.props.base_url}
                           edit_cart_item={this.state.edit_cart_item}

                           hideSclads={this.hideSclads}
                           product={this.state.current_product}
                           user={this.props.user}
                           refreshState={this.refreshState}
            />
        } else {
            return (
                <List>
                    <Fancybox>
                        {this.state.items.length > 0 ?

                            this.state.items.map((item, index) =>
                                <CartRow
                                    item={item}
                                    removeFromCart={this.removeFromCart}
                                    showEditCart={this.showEditCart}
                                    index={index}
                                    base_url={this.props.base_url}
                                    user={this.props.user}
                                />)
                            : <Cell>Корзина пуста</Cell>}
                    </Fancybox>
                    <CartTotal user={this.props.user} title="Сумма заказа: "/>
                </List>)
        }
    }

}

export default Cart;
